/**
 * 태그 배열을 오름차순으로 정렬합니다.
 *
 * @param tags - 정렬할 태그 배열
 * @returns 정렬된 새로운 태그 배열
 *
 * @example
 * sortTags(['beta', 'alpha', 'gamma']) // ['alpha', 'beta', 'gamma']
 * sortTags(['태그2', '태그1', '태그3']) // ['태그1', '태그2', '태그3']
 */
export const sortTags = (tags: string[]): string[] => {
  return [...tags].sort((a, b) => a.localeCompare(b));
};

/**
 * 태그 배열이 null/undefined일 수 있는 경우에도 안전하게 정렬합니다.
 *
 * @param tags - 정렬할 태그 배열 (null/undefined 가능)
 * @returns 정렬된 태그 배열, 입력이 null/undefined이면 빈 배열 반환
 *
 * @example
 * sortTagsSafe(['beta', 'alpha']) // ['alpha', 'beta']
 * sortTagsSafe(null) // []
 * sortTagsSafe(undefined) // []
 */
export const sortTagsSafe = (tags?: string[] | null): string[] => {
  if (!tags || tags.length === 0) return [];
  return sortTags(tags);
};
